import { render, staticRenderFns } from "./ChangePerms.vue?vue&type=template&id=64a166d5&scoped=true"
import script from "./ChangePerms.vue?vue&type=script&lang=js"
export * from "./ChangePerms.vue?vue&type=script&lang=js"
import style0 from "./ChangePerms.vue?vue&type=style&index=0&id=64a166d5&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a166d5",
  null
  
)

export default component.exports